/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UsageKind } from './usageKind';
import { ParkingPlace } from './parkingPlace';

/**
 * Usage of the vehicle.   (german: Nutzung des Fahrzeugs)   (bipro-fahrzeug::Fahrzeugnutzung)
 */
export interface VehicleUsage {
  parkingPlace?: ParkingPlace;
  usageKind?: UsageKind;
  /**
   * Driven kilometers per year.   (german: Jahreskilometer)   (bipro-fahrzeug::Jahresfahrleistung)
   */
  annualMileage?: number;
  /**
   * Birthday of the youngest vehicle user.   (german: Geburtsdatum jüngstes Nutzer)
   */
  birthdayYoungestUser?: string;
  /**
   * Birthday of the oldest vehicle user.   (german: Geburtsdatum ältester Nutzer)
   */
  birthdayOldestUser?: string;
}
export namespace VehicleUsage {}
